import { Routes } from '@angular/router';
const ɵ0 = () => import("./pages/pages.module.ngfactory").then(value => value.ChatQuizModuleNgFactory);
const routes = [
    { path: '', loadChildren: ɵ0 },
    { path: '**', redirectTo: 'redirected', pathMatch: 'full', }
];
export class AppRoutingModule {
}
export { ɵ0 };
